
import Group from "@core/Group.js";
import Price from "@core/Price.js";
import Recommend from "@core/Recommend.js";
import ViewFactory from "@factory/View.js";
import Constant from "@constant/index.js";
import { $util, $array, $event_publisher } from "@util/util.js";
import API from "@api/index.js";
import Alert from "@util/alert.js";
import Intercept from "@observer/Intercept.js";
//import ShippingAreaPC from "@vpc/ShippingArea.js";
//import ShippingAreaWap from "@vwap/ShippingArea.js";
import { Bridge } from "@shared/bridge";
import { inHarmonyApp } from '@/util/index.js';

export default class Engine {
	constructor() {
		// wap下编辑状态
		this._editStatus = false;
		this._wapIsEditIntercept = new Intercept();
		this._wapIsEditIntercept.init(null, this, "_editStatus")

		// wap编辑状态下记录选中的不可购买商品
		this._editSelectedDisablePurchaseGoods = [];
		this._editSelectedDisablePurchaseGoodsNum = 0;


		this._group = [];
		if (window._terminal == Constant.TERMINAL.PC) {
			this._goodsListContainerEl = $("div.good_list");
		} else {
			
			this._goodsListContainerEl = $("div.cart_wrap");
			this._invalidGoodsListContainerEl = $("div.cart_wrap_invalid div.invalid_goodslist");
		}

		this._currentTime = 0;
		this._price = new Price(this);
		if (window._shopId == 1) {
			this._recommend = new Recommend();
			this._recommendView = new ViewFactory().create(Constant.MODEL_TYPES.RECOMMEND, this._recommend);
		}
	}
	renderGoBackDOM() {
		try {
			if (inHarmonyApp()) {
				apputils?.getAppReference((res) => {
					if (res == 'appTabbar') {
						$('.header_left_goback').hide();
					} else {
						$('.header_left_goback').show();
					}
				})
			} else {
				$('.header_left_goback').show();
			}
		} catch (err) {
			console.log('===apputils catch', err)
			$('.header_left_goback').show();
		}
	}
	init() {
		this.renderGoBackDOM();
		localStorage.setItem('_test_cart_', 1);
		this._group = [];
		this._goodsListContainerEl.html("");

		API.getCart().then(x => {
			this._currentTime = x.t.timestamp;
			const nowDate = new Date();
			//客户本地时间与服务器时间的差值
			this._timeDiff = this._currentTime - nowDate.getTime();


			x.t.vendors.forEach(item => {
				item.sorted.forEach(g => {
					g.item._faId = item.id;
					g.item._faName = item.name;
					g.item._itemType = g.itemType;
					let data = { id: item.id, name: item.name, itemType: g.itemType, item: g.item, invalid: item.invalid };
					let _group = new Group();
					_group.init(data);
					this.addGroup(_group);
					let groupView = new ViewFactory().create(Constant.MODEL_TYPES.GROUP, _group);
					groupView.render(this._goodsListContainerEl, this._invalidGoodsListContainerEl); // 处理lists数据并渲染

					_group.readyToReadySku();
				})
			});

			//渲染智能推荐
			if (window._shopId == 1) {
				this._recommend.init().then(x => {
					this._recommend._data = this._recommend.analysis(x.t);
					this._recommendView.render();
				}).catch(err => {
					Alert.showTip(err.msg);
				})
			}
			//render price
			this._price.init(x.t);
			let priceView = new ViewFactory().create(Constant.MODEL_TYPES.PRICE, this._price);
			priceView.render();
			// lecoo商城不需要调用批量获取商品是否包含优惠券接口
			if (window._shopId != 18) {
				this.batchCouponStatus();
			}

			if (window._terminal == Constant.TERMINAL.PC) {
				this.navTop();
			} else {
				this.navTop_Wap();
			}

			this.renderLatag(this._group);


			// $('div.service_wrapper button.service-select-confirm').on("click",function(){
			//     $('div.service_wrapper').hide(); 
			// });
			// $('div.coupon_wrapper button.coupon-select-confirm').on("click",function(){
			//     $('div.coupon_wrapper').hide(); 
			// });
		})
			.catch(err => {
				err.msg ? Alert.showTip(err.msg) : Alert.showTip(err);
			})

		//消息处理
		this.notice();

		

		/* 重构了不需要JQ组件了 PRCECOM25-27140 Edited on March 25, 2026
    //配送区域
		if (window._terminal == Constant.TERMINAL.PC) {
			this._shippingArea = new ShippingAreaPC(true);
		} else {
			this._shippingArea = new ShippingAreaWap(true);
		}
    */


	}

	tick() {
		window.setInterval(() => {
			this._currentTime = this._currentTime + 1000;
			/*const myDate = new Date(this._currentTime);
			const my_CurrentDate = myDate.getHours() + '时'+ myDate.getMinutes() + '分'+ myDate.getSeconds() + '秒' + myDate.getMilliseconds() + '豪秒';
			console.log("我的时间："+my_CurrentDate);

			const nowDate = new Date();
			const currentDate = nowDate.getHours() + '时'+ nowDate.getMinutes() + '分'+ nowDate.getSeconds() + '秒' + nowDate.getMilliseconds() + '豪秒';
			console.log("当前时间："+currentDate);*/
		}, 1000)
	}

	getCoupon(params) {
		let _params = {
			shopId: window._shopId,
			getTerminal: window._terminal,
			terminal: window._terminal,
			list: JSON.stringify(params)
		};
		return API.getHasCoupons(_params);
	}

	batchCouponStatus() {
		let mainSkus = $util.getPurchaseEnabledMainSkus(this._group);
		let params = [];
		mainSkus.forEach(item => {
			params.push({ goodscode: item.goodscode, categorycode: item.categorycode, facode: item.facode });
		})
		let arrss = ''
		this.getCoupon(params).then(x => {
			mainSkus.map((items, indexs) => {
				x.t.forEach((item, idx) => {
					if (indexs == idx) {

						item.itemType = items.mainSku._parent._data.item._itemType
						item.purchaseEnable = items.mainSku._parent._data.item.purchaseEnable
						item.invalid = items.mainSku._parent._data.item.invalid
						item.skus = items.mainSku._originData?.skus || []
					}
				})

				x.t.forEach((item, idx) => {
					if (item.purchaseEnable == false && item.invalid == false) {
						mainSkus[idx].mainSku._hasCoupons = false;
					} else if (item.invalid) {
						mainSkus[idx].mainSku._hasCoupons = false;
					}
					else if (item.status == 1 && (item.itemType == 0 || item.itemType == 2 || (item.itemType === 9 && item.skus.length === 0))) {
						mainSkus[idx].mainSku._hasCoupons = true;
					} else {
						mainSkus[idx].mainSku._hasCoupons = false;
					}
				})
			})

		}).catch(err => {
			console.log(`获取是否有优惠券出错`);
		})
	}

	//重新渲染购物车
	reRenderCart(data) {
		this._group = [];
		if (window._terminal == Constant.TERMINAL.PC) {
			this._goodsListContainerEl.html("");
		} else {
			this._goodsListContainerEl.html("");
			this._invalidGoodsListContainerEl.html("");
		}

		data.vendors.forEach(item => {
			item.sorted.forEach(g => {
				g.item._faId = item.id;
				g.item._faName = item.name;
				g.item._itemType = g.itemType;
				let data = { id: item.id, name: item.name, itemType: g.itemType, item: g.item, invalid: item.invalid };
				let _group = new Group();
				_group.init(data);
				this.addGroup(_group);
				let groupView = new ViewFactory().create(Constant.MODEL_TYPES.GROUP, _group);
				groupView.render(this._goodsListContainerEl, this._invalidGoodsListContainerEl);

				_group.readyToReadySku();
			})
		});
		// lecoo商城不需要调用批量获取商品是否包含优惠券接口
		if (window._shopId != 18) {
			this.batchCouponStatus();
		}

	}

	//渲染埋点数据
	renderLatag(group) {
		let _latagGoods = ``, _hasChecked = false;

		group.map(item => {
			// if(!item._invalid && item._isChecked){
			item._mainSkus.map((skusItem, index) => {
				if (skusItem._isChecked) {
					_hasChecked = true;
					if (skusItem?._deliveryPrice > 0) {
						_latagGoods += skusItem._id + ":" + skusItem._count + `:非赠品:dsj${skusItem._id},`;
					} else {
						_latagGoods += skusItem._id + ":" + skusItem._count + ":非赠品:null,";
					}
					//服务
					if (skusItem._service && skusItem._service._items && skusItem._service._items.length > 0) {
						skusItem._service._items.map(serviceItem => {
							_latagGoods += serviceItem._id + ":" + serviceItem._count + ":非赠品:null,";
						})
					}
					//赠品
					if (skusItem._gift && skusItem._gift._items && skusItem._gift._items.length > 0) {
						skusItem._gift._items.map(giftItem => {
							_latagGoods += giftItem._id + ":" + giftItem._count + ":是赠品:null,";
						})
					}
					//选件
					if (skusItem._option && skusItem._option._items && skusItem._option._items.length > 0) {
						skusItem._option._items.map(item => {
							_latagGoods += item._id + ":" + item._count + ":非赠品:null,";
						})
					}

					//套餐
					if (skusItem._package && skusItem._package._items && skusItem._package._items.length > 0) {
						skusItem._package._items.map(item => {
							_latagGoods += item._id + ":" + item._count + ":非赠品:null,";
						})
					}
				}
			})
			if (_hasChecked) {
				_latagGoods = _latagGoods.substring(0, _latagGoods.length - 1);
				_latagGoods += "|";
			}
			// }               
		})
		// if(_latagGoods.length == 1){
		//     _latagGoods = "latag_pc_odersubmit_submit_";
		// }else{
		// _latagGoods = "latag_pc_odersubmit_submit_"+_latagGoods.substring(0,_latagGoods.length-1);
		// }

		if (window._terminal == Constant.TERMINAL.PC) {
			_latagGoods = "latag_pc_cart_submit_" + _latagGoods.substring(0, _latagGoods.length - 1) + '_null_null';
			$("#gocheckout").attr("latag", _latagGoods);
		} else {
			_latagGoods = "latag_wap_cart_submit_" + _latagGoods.substring(0, _latagGoods.length - 1) + '_null_null';
			$(".settlement").attr("latag", _latagGoods);
		}
	}

	notice() {
		//删除主品
		$event_publisher.on(Constant.EVENT_KEY.REMOVE_MAINSKU, (model) => {
			let _group = model._parent;
			//如果是满减
			if (_group._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE) {
				_group.removeMainSku(model);
				if (_group._mainSkus.length == 0) {
					_group._view._el.remove();
				} else {
					model._view._fullMainSkuEl.remove();
				}
			} else {
				//因为套餐的主品itemId就是当前group的itemid，所以直接在这里处理了
				_engine.removeGroup(_group);
				_group._view._el.remove();
			}
		});

		//价格变更
		$event_publisher.on(Constant.EVENT_KEY.PRICE, (data) => {
			let t = new Date(), that = this;

			this._price.init(data);
			this._price._view.render();
			t = new Date();
			setTimeout(function (data) {
				t = new Date();
				that.renderLatag(that._group);
				t = new Date();
			}, 500);
		});


		//删除服务
		$event_publisher.on(Constant.EVENT_KEY.REMOVE_SERVICE, (data) => {
			data.model.removeServiceItemById(data.id);
			if (data.model._items.length == 0) {
				data.model._view._el.remove();
			} else {
				data.model._view._itemEls[data.id].remove();
			}
		});

		//修改数量，主品
		$event_publisher.on(Constant.EVENT_KEY.MODIFY_MAINSKU_COUNT, (data) => {
			let t = new Date();
			let _mainSkuModel = data.model;
			let _itemId = data.model._itemId;
			let _data = data.data;
			let _mainSkuData = null;
			//如果是选件
			if (_mainSkuModel._parent._itemType == Constant.GROUP_TYPE.OPTION.TYPE) {
				_mainSkuData = $util.getMainSkuByIdAndItemId(_mainSkuModel._id, _itemId, _data, _mainSkuModel._parent._itemType);
				if (_mainSkuData && _mainSkuData.group && _mainSkuData.mainSku) {
					//选件修改之后如果主品的选中状态变化了则重新渲染购物车,否则只重新渲染主品的 Additional                  
					if (_mainSkuModel._invalid != _mainSkuData.group.invalid || _mainSkuModel._purchaseEnable != _mainSkuData.group.purchaseEnable) {
						this.reRenderCart(data.data);
					} else {
						_mainSkuData && _mainSkuData.mainSku && _mainSkuModel.init(_mainSkuData.mainSku[0], _mainSkuData.group);
						_mainSkuModel && _mainSkuData.mainSku && _mainSkuModel.setAdditional();
						_mainSkuModel && _mainSkuData.mainSku && _mainSkuModel.readyToReadyAdditional();
					}
				} else {
					// 删除所有选件之后如果主品变成了普通的商品则重新渲染购物车
					this.reRenderCart(data.data);
				}
			} else if (_mainSkuModel._parent._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE) { //满减
				// 满减的时候需要遍历更新group下面的所有商品
				_mainSkuModel._parent._mainSkus.forEach(item => {
					_mainSkuData = $util.getMainSkuByIdAndItemId(item._id, item._itemId, _data, item._parent._itemType);
					if (_mainSkuData && _mainSkuData.mainSku && _mainSkuData.mainSku.type == Constant.GROUP_TYPE.OPTION.TYPE) {
						_mainSkuData && item.init(_mainSkuData.mainSku.skus[0], _mainSkuData.mainSku);
					} else {
						item.init(_mainSkuData.mainSku, _mainSkuData.mainSku);
					}
					// group的header信息跟随触发数量变化的主品更新一次就行
					if (item._itemId == _mainSkuModel._itemId) {
						_mainSkuData && (_mainSkuModel._parent._groupMsg = _mainSkuData.group.stip);
						_mainSkuData && (_mainSkuModel._parent._groupTag = (_mainSkuData.group.rePrice && _mainSkuData.group.rePrice.showAmount) > 0 ? "再逛逛" : "去凑单");
						_mainSkuModel && _mainSkuModel.setAdditional();
						_mainSkuModel && _mainSkuModel.readyToReadyAdditional();
					}
				})
			} else if (_mainSkuModel._parent._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE) { //套餐                
				let newData = $util.getGroupByItemId(_mainSkuModel._parent._itemId, data.data.vendors);
				if (newData) {
					_mainSkuModel._parent._groupCount = newData.num;
					_mainSkuModel._parent._groupTotalPrice = newData.xiaoji.amount;
					_mainSkuModel._parent.initPackage(newData);
					_mainSkuModel.init(newData.skus[0], newData);
					_mainSkuModel.setAdditional();
					_mainSkuModel.readyToReadyAdditional();
				}
			} else {
				_mainSkuData = $util.getMainSkuByIdAndItemId(_mainSkuModel._id, _itemId, _data, _mainSkuModel._parent._itemType);
				_mainSkuData && _mainSkuModel.init(_mainSkuData.mainSku, _mainSkuData.group);
				_mainSkuModel && _mainSkuModel.setAdditional();
				_mainSkuModel && _mainSkuModel.readyToReadyAdditional();
			}
			t = new Date();
			this.reRenderCart(data.data);

		});

		//主品选中状态变更
		$event_publisher.on(Constant.EVENT_KEY.CHANGE_MAINSKU_ACTIVE, (data) => {
			// let _mainSkuModel = data.model;
			// items包含 选件 & 套餐 & 单品，返回的是group对象，如果是满减，则返回的是当前MainSku的对象，仅用于查找checked状态             
			// let _item = $util.getGroupByIdAndItemId(_mainSkuModel._id, _mainSkuModel._itemId, data.data, _mainSkuModel._parent._itemType);
			// _item && (_mainSkuModel._isChecked = _item.check == 0?false:true);   

			let _mainSkuModel = data.model;
			let _itemId = data.model._itemId;
			let _data = data.data;
			let _mainSkuData = null;

			//满减
			if (_mainSkuModel._parent._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE) {
				// 满减的有一个选中，header就显示选中SHOP-37578
				_mainSkuModel._parent._isChecked = false;
				// 满减的时候需要遍历更新group下面的所有商品                 
				_mainSkuModel._parent._mainSkus.forEach(item => {
					_mainSkuData = $util.getMainSkuByIdAndItemId(item._id, item._itemId, _data, item._parent._itemType);
					if (_mainSkuData && _mainSkuData.mainSku && _mainSkuData.mainSku.type == Constant.GROUP_TYPE.OPTION.TYPE) {
						item.init(_mainSkuData.mainSku.skus[0], _mainSkuData.mainSku);
						// 满减的有一个选中，header就显示选中SHOP-37578
						if (_mainSkuData.mainSku.check && _mainSkuData.mainSku.check == 1) {
							_mainSkuModel._parent._isChecked = true;
						}

					} else {
						_mainSkuData && item.init(_mainSkuData.mainSku, _mainSkuData.mainSku);
						// 满减的有一个选中，header就显示选中SHOP-37578
						if (_mainSkuData.mainSku.check && _mainSkuData.mainSku.check == 1) {
							_mainSkuModel._parent._isChecked = true;
						}
					}
					// group的header信息跟随触发选中状态变化的主品更新一次就行
					if (item._itemId == _mainSkuModel._itemId) {
						_mainSkuData && (_mainSkuModel._parent._groupMsg = _mainSkuData.group.stip);
						_mainSkuData && (_mainSkuModel._parent._groupTag = (_mainSkuData.group.rePrice && _mainSkuData.group.rePrice.showAmount) > 0 ? "再逛逛" : "去凑单");
					}



				})
			} else {
				let _item = $util.getGroupByIdAndItemId(_mainSkuModel._id, _mainSkuModel._itemId, data.data, _mainSkuModel._parent._itemType);
				_item && (_mainSkuModel._isChecked = _item.check == 0 ? false : true);
			}

		});

		//全选状态变更
		$event_publisher.on(Constant.EVENT_KEY.CHANGE_ALL_ACTIVE, (data) => {
			$util.setAllMainSkuStatus(this._group, data);
			$util.setAllPackageStatus(this._group, data);
		});

		//全选状态变更
		$event_publisher.on(Constant.EVENT_KEY.RERENDER_CART, (data) => {
			//重新渲染购物车
			this.reRenderCart(data);
		});



		//套装数量变更--需要重新渲染Groupy以及mainSku
		$event_publisher.on(Constant.EVENT_KEY.MODIFY_PACKAGE_COUNT, (data) => {
			let group = data.model;
			let mainSku = group._mainSkus[0];
			let newData = $util.getGroupByItemId(group._itemId, data.data.vendors);
			if (newData) {
				group._groupCount = newData.num;
				group._groupTotalPrice = newData.xiaoji.amount;
				group.initPackage(newData);
				mainSku.init(newData.skus[0], newData);
				mainSku.setAdditional();
				mainSku.readyToReadyAdditional();
			}
		});

		//套餐选中状态变更
		$event_publisher.on(Constant.EVENT_KEY.CHANGE_PACKAGE_ACTIVE, (data) => {
			let _groupModel = data.model;
			let _item = $util.getGroupByItemId(_groupModel._itemId, data.data.vendors);
			if (_item) {
				_groupModel._isChecked = _item.check == 0 ? false : true;
				_groupModel._mainSkus[0]._isChecked = _groupModel._isChecked;
			}
		});

		//删除Group/目前只有套餐允许删除
		$event_publisher.on(Constant.EVENT_KEY.REMOVE_GROUP, (group) => {
			_engine.removeGroup(group);
			group._view._el.remove();
		});
    // PC/WAP Vue组件发起reRender cart
		Bridge.on(Bridge.EventType.renderCart, (x) => {
      //console.log('Bridge renderCart');
			this._currentTime = x.t.timestamp;
			const nowDate = new Date();
			//客户本地时间与服务器时间的差值
			this._timeDiff = this._currentTime - nowDate.getTime();
			this.reRenderCart(x.t);
			this._price.init(x.t);
			this._price._view.render();
		})
    
    /**
     * 监听私人定制修改
     */
    Bridge.on(Bridge.EventType.ChangePersonal, (data) => {
      this._currentTime = x.t.timestamp;
			const nowDate = new Date();
			//客户本地时间与服务器时间的差值
			this._timeDiff = this._currentTime - nowDate.getTime();
			this.reRenderCart(x.t);
			this._price.init(x.t);
			this._price._view.render();
      //const checkoutData = getTerminal() === define.PC ? DomHandle_pc.GetCheckOutData_PC() : DomHandle_wap.GetCheckOutData();
      //// personalization 字段仅当修改时传即可
      //const value = data && data.length > 0 ? JSON.stringify(data) : 'DEL'
      //_model_Settlement.checkOut({ ...checkoutData, personalization: value }).then(() => {
      //  // 触发详情接口
      //  _detailDataSource._dataState = 1;
      //  Bridge.togglePersonalDialog(false);
      //})
    })
	}

	addGroup(group) {
		this._group.push(group);
	}

	removeGroup(group) {
		this._group = $array.removeItem(this._group, { _itemId: group._itemId });
	}

	start() {
		this.init();
	}

	navTop() {
		var $top = $(".cart_settlement"),
			wheight = $(window).height(),
			dheihgt = $(document).height(),
			_bottom = 0;
		if (window._shopId == 1) {
			_bottom = 970;
		}
		if (window._shopId == 3) {
			_bottom = 46;
		}
		if (window._shopId == 18) {
			_bottom = 460;
		}
		if ((dheihgt - wheight) > _bottom) {
			$top.addClass("cartFixed");
			$(".cart_settlement_box").css("width", "100%");
		} else {
			$top.removeClass("cartFixed");
			$(".cart_settlement_box").css("width", "1200px");
		}
		$(window).scroll(function () {
			if ($(window).scrollTop() >= ($(document).height() - $(window).height() - _bottom)) {
				$top.removeClass("cartFixed");
				$(".cart_settlement_box").css("width", "1200px");
			} else {
				$top.addClass("cartFixed");
				$(".cart_settlement_box").css("width", "100%");
			}
		})
	}
	navTop_Wap() {
		let $top = $(".cart_settlement"),
			wheight = $(window).height(),
			dheihgt = $(document).height();
		wheight < dheihgt ? $top.addClass("cartFixed") : $top.removeClass("cartFixed");
		$(window).scroll(function () {
			($(window).scrollTop() >= $(document).height() - $(window).height()) ? $top.removeClass("cartFixed") : $top.addClass("cartFixed");
		})
	}
}